/** @format */
// Migrated from AngularJS: plans.comp.js
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Plan } from 'common-typescript/types';

// Default change detection: this is a routing shell whose only job is to host <ui-view> transitions.
// UI Router instantiates leaf components outside the OnPush dirty-check path, so OnPush leaves the
// shell rendered blank until the next NgZone tick. The project's other ui-view hosts also use the
// default strategy (see e.g. ProfileShellComponent, PaymentAndGrantTabsComponent, SearchTabsComponent).
@Component({
    selector: 'app-tutoring-plans',
    templateUrl: './tutoring-plans.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class TutoringPlansComponent {
    @Input() plans: Plan[] = [];
    @Input() selectedPlan: Plan;

    constructor(public state: StateService) {}
}
